<template>
  <section id="section__purchases" class="view-container">
    <div class="width-100 height-100">
      <WholesalerFinderDialog ref="whosalerFinder" />
      <v-row no-gutters>
        <v-col cols="12">
          <p class="font--m-4 mb-0">
            {{ pickedDate | dateKorean }} 주문목록
            <v-icon @click="dateModal = true">mdi-calendar</v-icon>
          </p>
          <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="pickedDate" width="300px">
            <v-date-picker
              ref="picker"
              v-model="pickedDate"
              :max="new Date().toISOString().substr(0, 10)"
              min="2022-01-01"
              @change="dateSave"
            >
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>

      <template v-if="isLoading == false && purchase">
        <v-row v-if="false" no-gutters class="mt-4">
          <v-col cols="12" class="tools">
            <BasicButton
              color="white"
              height="23px"
              :disabled="saveLoading"
              :loading="saveLoading"
              @click="initial()"
            >
              수량 초기화
            </BasicButton>

            <BasicButton
              color="white"
              height="23px"
              :disabled="saveLoading"
              :loading="saveLoading"
              @click="saveList()"
            >
              임시 저장
            </BasicButton>

            <BasicButton
              height="23px"
              :disabled="saveLoading"
              :loading="saveLoading"
              @click="exportToExcel()"
            >
              엑셀 다운로드
            </BasicButton>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-4">
          <v-col v-for="mall in malls" :key="mall" cols="12">
            <p class="mall-tag font--m-4 mb-2">(img){{ mallSet[mall].mall.providerName }}</p>
            <ProductCard
              v-for="item in mallSet[mall].items"
              :key="item.uuid"
              :product="item"
              showEdit
              @emitOpenWhosalerFinder="openWhosalerFinder"
              @emitDeleteProduct="deleteItem"
            />
            <v-divider class="my-5"></v-divider>
          </v-col>

          <v-col cols="12" v-if="additions.length > 0">
            <p class="mall-tag font--m-4 mb-2">추가 입력</p>
            <ProductCard
              v-for="add in additions"
              :key="add.uuid"
              :product="add"
              isAddition
              @emitOpenWhosalerFinder="openWhosalerFinder"
              @emitDeleteProduct="deleteAdditionalItem"
            />
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-5">
          <v-col cols="12" class="mb-5">
            <div class="button-bottom-add">
              <BasicButton @click="addProduct()">
                <v-icon color="white" class="add-icon">add_circle_outline</v-icon>
                추가 입력
              </BasicButton>
            </div>
          </v-col>
          <v-col cols="12">
            <OverlayProductsConfirmButton ref="productsConfirmBtn">
              <BasicButton :disabled="saveLoading" :loading="saveLoading" @click="saveAndNext()">
                사입 주문하기
              </BasicButton>
            </OverlayProductsConfirmButton>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row no-gutters class="text-center">
          <v-col cols="12" style="padding-top: 10rem">
            <img class="circle-loading" src="@/assets/images/loading/loading--circle.gif" />
            <p class="font--m-3 mt-2 mb-0">
              주문목록을 열심히 <br />
              가져오고 있어요
            </p>
          </v-col>
        </v-row>
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { uuid } from '@/util'

import ProductCard from '@/components/product/ProductCard.vue'
import WholesalerFinderDialog from '@/components/popups/WholesalerFinderDialog.vue'
import OverlayProductsConfirmButton from '@/components/overlay/button/OverlayProductsConfirmButton.vue'

export default {
  components: {
    ProductCard,
    WholesalerFinderDialog,
    OverlayProductsConfirmButton,
  },
  data() {
    return {
      getLoading: false,
      initialLoading: false,
      saveLoading: false,
      pickedDate: null,
      dateModal: false,
      purchase: null,
      mallSet: {},
      orderDialog: false,
      additions: [],
    }
  },
  computed: {
    ...mapGetters('product', ['getDefaultProduct']),
    malls() {
      return Object.keys(this.mallSet)
    },
    isLoading() {
      return this.getLoading || this.initialLoading
    },
  },
  watch: {
    pickedDate(v) {
      this.dateModal = false
      this.getPurchases(v)
    },
  },
  created() {
    this.pickedDate = this.$moment(Date.now()).format('yyyy-MM-DD')
  },
  methods: {
    ...mapActions('product', [
      'getPurchasesDetail',
      'addPurchases',
      'productsDetailDownloadExcel',
      'removeProductsDetail',
    ]),
    dateSave(date) {
      this.$refs.dialog.save(date)
    },
    openWhosalerFinder(product) {
      this.$refs.whosalerFinder.switchDialog(product)
    },
    async deleteItem(product) {
      const confirm = await this.$swal.basic.confirm('선택하신 상품을 정말 삭제하시겠습니까?')

      if (confirm.isConfirmed !== true) {
        return
      }

      const mallId = product.mall.uuid
      const idx = this.mallSet[mallId].items.findIndex((item) => item.uuid === product.uuid)
      if (idx > -1) {
        this.mallSet[mallId].items.splice(idx, 1)
      }
    },
    async deleteAdditionalItem(product) {
      const confirm = await this.$swal.basic.confirm('선택하신 상품을 정말 삭제하시겠습니까?')

      if (confirm.isConfirmed !== true) {
        return
      }

      const idx = this.additions.findIndex((addi) => addi.uuid === product.uuid)
      if (idx > -1) {
        this.additions.splice(idx, 1)
      }
    },
    setDefaultValue(item) {
      const defaultValue = this.getDefaultProduct

      if (!item?.uuid) {
        defaultValue.uuid = uuid()
      }

      Object.keys(defaultValue)
        .filter((k) => !item?.[k] && defaultValue.hasOwnProperty(k))
        .forEach((k) => (item[k] = defaultValue[k]))

      return item
    },
    addProduct() {
      const add = this.setDefaultValue({})
      this.additions.push(add)
    },
    convertProduct(product) {
      if (!!product.title || !!product.titleForPurchase) {
        const temp = { ...product }
        delete temp.uuid
        if (temp.wholesaler.uuid === null) {
          delete temp.wholesaler
        }
        return temp
      }
      return null
    },
    async initial() {
      const confirm = await this.$swal.basic.confirm(
        '수정된 내용을 초기화하고 최초의 주문 목록을 다시 불러옵니다',
      )

      if (confirm.isConfirmed !== true) {
        return
      }

      this.initialLoading = true

      try {
        const data = await this.removeProductsDetail(this.purchase.uuid)
        if (data.status === 204) {
          this.getPurchases(this.pickedDate)
        }
      } catch (e) {
        if (e.status === 405) {
          this.getPurchases(this.pickedDate)
        } else {
          this.$swal.basic.alert('현재 매출 데이터를 불러올 수 없습니다.')
        }
      } finally {
        this.initialLoading = false
      }
    },
    async getPurchases(date) {
      this.getLoading = true
      const data = await this.getPurchasesDetail({ date })
      const tempSet = {}
      data?.itemSet.forEach((item) => {
        this.setDefaultValue(item)
        const mallId = item?.mall?.uuid

        if (tempSet?.[mallId]) {
          tempSet[mallId]['items'].push(item)
        } else {
          const temp = {
            mall: item.mall,
            items: [],
          }
          temp.items.push(item)
          tempSet[mallId] = temp
        }
      })
      this.mallSet = tempSet
      this.purchase = data
      this.getLoading = false
    },
    async saveList() {
      if (this.saveLoading) {
        return
      }

      let result = null
      this.saveLoading = true

      const param = {
        date: this.purchase.date,
        itemSet: [],
      }

      this.malls.forEach((mall) => {
        const tempList = this.mallSet[mall].items.reduce((prev, curr) => {
          const t = this.convertProduct(curr)
          if (t) {
            prev.push(t)
          }
          return prev
        }, [])
        param.itemSet = [...param.itemSet, ...tempList]
      })

      this.additions.forEach((add) => {
        const t = this.convertProduct(add)
        if (t) {
          param.itemSet.push(t)
        }
      })

      if (param.itemSet.length < 1) {
        return
      }

      try {
        const data = await this.addPurchases(param)
        result = data
      } finally {
        this.saveLoading = false
      }

      return result
    },
    async exportToExcel() {
      const confirm = await this.$swal.basic.confirm('현재 입력된 정보를 엑셀로 다운로드 합니다')

      if (confirm.isConfirmed !== true) {
        return
      }

      try {
        const data = await this.saveList()

        if (data?.uuid) {
          const fileName = `${this.pickedDate}_사입목록`
          this.productsDetailDownloadExcel({ uuid: data.uuid, fileName })
        } else {
          this.$swal.basic.error(
            '엑셀 데이터를 불러오던 중 에러가 발생했습니다. 다시 시도해주세요.',
          )
        }
      } catch (e) {
        this.$swal.basic.error('엑셀 데이터를 불러오던 중 에러가 발생했습니다. 다시 시도해주세요.')
      }
    },
    async saveAndNext() {
      const confirm = await this.$swal.basic.confirm('입력하신 정보로 사입 주문을 진행합니다.')

      if (confirm.isConfirmed !== true) {
        return
      }

      try {
        const data = await this.saveList()

        if (data?.uuid) {
          this.$refs.productsConfirmBtn.openDialog(data.uuid)
          // this.$router.push({ name: 'purchases/detail/choice', params: { uuid: data.uuid } })
        } else {
          this.$swal.basic.error('사입 주문목록 저장중 에러가 발생했습니다. 다시 시도해주세요.')
        }
      } catch (e) {
        this.$swal.basic.error('사입 주문목록 저장중 에러가 발생했습니다. 다시 시도해주세요.')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#section__purchases {
  padding-top: 2rem;
}

.circle-loading {
  width: 150px;
  object-fit: contain;
}

.tools {
  display: flex;

  button {
    flex: 0 0 100px;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.mall-tag {
  display: flex;
  align-items: center;

  background-color: $gray-80;

  padding: 10px 5px;
}

.p-card {
  margin-bottom: 12px;
}
</style>
